import SupportRequestsParent from "../components/Notifications/SupportRequestsParent";
import { Paper, useTheme } from "@mui/material";

 const SupportRequestsPage = (props: any) => {
    const theme = useTheme();
    return (
        <Paper 
          component={"main"} 
          className='off-white'
          sx={{backgroundColor: theme.palette.background.default}}
        >
            <SupportRequestsParent 
                allApplications={props.allApplications} 
                supportRequestsList={props.supportRequestsList} 
                acknowledgeNotification={props.acknowledgeNotification}
                callSupportRequestsAPI={props.callSupportRequestsAPI} />
        </Paper>
    )
}

export default SupportRequestsPage;
